<div class="ac-variants-coverages-row-value">
    <span class="material-icons" [class.icon-none]="icon === '—'" [class.icon-check]="icon === 'check'">{{icon}}</span>
    <span *ngIf="!this.icon">{{ value | translate }}</span>
</div>
